/* VEXAR — fiche produit.
   Ce fichier impose l'état final des 4 cartes et de l'accordéon.
   Il vit dans assets/ : l'éditeur de thème ne le réécrit jamais,
   contrairement à templates/product.json. */
(function () {
  'use strict';

  var O = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">';
  var C = '</svg>';

  var TILES = [
    { icon: O + '<path d="M8.5 3.5 4.5 6l1.4 3 1.6-.9V20h9V8.1l1.6.9L19.5 6l-4-2.5h-1.6a2 2 0 0 1-3.8 0z"/>' + C,
      title: 'Matières', sub: (window.VX_MATIERES || '') },
    { icon: O + '<path d="M3 8.5 12 4l9 4.5-9 4.5z"/><path d="M3 8.5v7L12 20l9-4.5v-7"/><path d="M12 13v7"/>' + C,
      title: 'Garantie', sub: 'Ouvrez le colis avant de payer' },
    { icon: O + '<path d="M2.5 6h10.5v10H2.5z"/><path d="M13 9.5h3.8l2.7 2.8V16H13z"/><circle cx="6.8" cy="17.6" r="1.7"/><circle cx="16.6" cy="17.6" r="1.7"/>' + C,
      title: 'Livraison & paiement', sub: 'Paiement à la livraison' },
    { icon: O + '<path d="M4.5 9.5h10a4.5 4.5 0 0 1 0 9H8.5"/><path d="M8 5.5 4 9.5l4 4"/>' + C,
      title: 'Échanges', sub: '1er échange de taille offert' }
  ];

  var SIZES = 'S — 50–60 kg / 165–173 cm<br>M — 60–72 kg / 170–178 cm<br>'
            + 'L — 72–85 kg / 175–183 cm<br>XL — 85–95 kg / 178–185 cm<br>'
            + '2XL — 95–110 kg / 183–190 cm';

  function setSummaryText(summary, text) {
    var walker = document.createTreeWalker(summary, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.trim()) { node.nodeValue = text; return true; }
    }
    return false;
  }

  function applyTiles(root) {
    var all = root.querySelectorAll('.group-block');
    var cards = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelectorAll('.icon-block').length === 1 &&
          all[i].querySelectorAll('.group-block').length === 0) cards.push(all[i]);
    }
    if (cards.length < 4) return false;
    for (var j = 0; j < 4; j++) {
      var card = cards[j], cfg = TILES[j];
      var box = card.querySelector('.group-block-content') || card;
      var ib = card.querySelector('.icon-block');
      if (ib && ib.getAttribute('data-vx') !== '1') {
        ib.innerHTML = cfg.icon;
        ib.setAttribute('data-vx', '1');
      }
      var tb = card.querySelector('.text-block');
      if (tb) {
        var p = tb.querySelector('p') || tb;
        if (p.textContent.trim() !== cfg.title) p.textContent = cfg.title;
      }
      var sub = box.querySelector('.vx-sub');
      if (cfg.sub) {
        if (!sub) { sub = document.createElement('div'); sub.className = 'vx-sub'; box.appendChild(sub); }
        if (sub.textContent !== cfg.sub) sub.textContent = cfg.sub;
      } else if (sub) {
        sub.parentNode.removeChild(sub);
      }
    }
    return true;
  }

  function applyAccordion(root) {
    var rows = root.querySelectorAll('details');
    for (var i = 0; i < rows.length; i++) {
      var d = rows[i];
      if (d.closest && d.closest('.vx-acc')) continue;
      var s = d.querySelector('summary');
      if (!s) continue;
      var t = s.textContent.trim();
      if (t === 'Shipping & Returns' || t === 'Livraison et retours') {
        d.style.display = 'none';
        continue;
      }
      if (t === 'Details' || t === 'Détails') {
        setSummaryText(s, 'Guide des tailles');
        var body = d.querySelector('.text-block p') || d.querySelector('.text-block');
        if (body && body.getAttribute('data-vx') !== '1') {
          body.innerHTML = SIZES;
          body.setAttribute('data-vx', '1');
        }
      }
    }
  }

  var done = false;
  function run() {
    var root = document.querySelector('.product-details');
    if (root) {
      done = applyTiles(root) || done;
      applyAccordion(root);
    }
    if (done || !root) document.documentElement.classList.remove('vx-pending');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // L'éditeur de thème et les changements de variante re-rendent la section.
  var pending = null;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; run(); }, 60);
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', run);

  // Filet de sécurité : ne jamais laisser la page masquée.
  setTimeout(function () { document.documentElement.classList.remove('vx-pending'); }, 2500);
})();
